module.exports = __webpack_public_path__ + "img/imgStep02.39876a37.png";